import { Resource } from "react-admin";
import CustomerIcon from "@material-ui/icons/Mood";
import React from "react";
import Edit from "./Edit";
import { POLICY_CUSTOMERS_MAPPINGS } from "../../common/rolesManagement";
import PermissionDenied from "../../components/PermissionDenied";

export default permissions => (
    <Resource
        name="customers-mappings"
        icon={CustomerIcon}
        edit={
            permissions &&
            (permissions.includes(POLICY_CUSTOMERS_MAPPINGS.UPDATE) ||
                permissions.includes(POLICY_CUSTOMERS_MAPPINGS.SAFE_UPDATE))
                ? Edit
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/CustomersMapping/index.js